import React from "react";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import _setFile from "./actions";
import {
  loadUploadedFile,
  updateSelectedIndex,
} from "../../Containers/EmailValidation/actions";
import Session from "../../utility/session";
import { switchTab } from "../EmailValidation/actions";

const mapStateToProps = (state) => ({
  emailverificationinfo: state.emailverificationinfo,
  username: state.loginInfo.username,
  fileUpload: state.fileUpload,
});
class FileUpload extends React.Component {
  constructor(props) {
    super(props);
  }
  onDrop(files) {
    const { dispatch } = this.props;

    // console.log("ondrop"+dispatch);
    const userData = {
      skip: 0,
      limit: this.props.skip + this.props.limit,
      initial: false,
      append: false,
      uploadedResults: this.props.emailverificationinfo.uploadedResults,
    };
    this.props.dispatch(_setFile(files, userData));
    this.props.dispatch(switchTab("bulk"));
    // this.props.dispatch(
    //   loadUploadedFile({ username:Session.getItem("current_username")})
    // );
  }
  render() {
    const DropZoneStyles = {};
    const { accept, dispatch } = this.props;
    // console.log("dispatch"+dispatch);
    return (
      <div>
        <div className="dropzone form-group clearfix">
          {this.props.fileUpload.status ? (
            <div
              style={{
                position: "absolute",
                height: "100%",
                left: 0,
                top: 0,
                backgroundColor: "#ccc",
                opacity: "0.5",
                right: 0,
                textAlign: "center",
              }}
            >
              <img src="assets/images/loading.gif" />
            </div>
          ) : (
            ""
          )}

          <div className="product_price text-center" style={{ marginTop: 0 }}>
            <Dropzone
              onDrop={this.onDrop.bind(this)}
              multiple={false}
              disablePreview={false}
              style={DropZoneStyles}
            >
              {/* <i
                className="fa fa-cloud-upload"
                style={{
                  fontSize: 80 + "px",
                  fontWeight: 200,
                  opacity: 0.5,
                  float: "left",
                  position: "relative",
                  left: 40 + "px",
                  top: 10
                }}
              /> */}
              <img
                src="assets/images/icon-upload-files.png"
                className="cloud-upload"
              />

              <span className="price-tax">
                Drag & Drop a CSV, TXT, XLS, XLSX or ODS file
              </span>
              <div className="uploadBtn">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-target=".bs-example-modal-lg"
                >
                  <i className="fa fa-upload" aria-hidden="true" /> Upload Email
                  List
                </button>
              </div>
              <br />
            </Dropzone>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(FileUpload);



// WEBPACK FOOTER //
// ./src/Containers/BulkValidation/index.js